import { FC } from 'react';
import { useHistory, useParams } from 'react-router';

import useAuthenticatedAction from 'common/hooks/useAuthenticatedAction';
import SunshineLoader from 'components/_core/SunshineLoader';
import PasscodeInput from 'components/PasscodeInput';

import useCardSecurityDetails from '../../hooks/useCardSecurityDetails';
import NavigationHeader from '../NavigationHeader';
import locales from './locales';
import { LoaderContainer, Root, Subtitle, Title } from './styles';
import { CardDetailsPasscodeParams, CardDetailsPasscodeProps } from './types';

const CardDetailsPasscode: FC<CardDetailsPasscodeProps> = ({
  creditCardId,
  scope,
}) => {
  const { operationId } = useParams<CardDetailsPasscodeParams>();
  const history = useHistory();

  const shouldCopy = operationId === 'copy-details';

  const { getCardSecurityDetails } = useCardSecurityDetails({
    creditCardId,
    shouldCopy,
  });

  const onPasscodeSuccess = async (token: string) => {
    const success = await getCardSecurityDetails(token);
    if (success) {
      history.goBack();
    }
  };

  const { isLoading, onPasscodeSubmit } = useAuthenticatedAction({
    onPasscodeSuccess,
    scope,
  });

  return (
    <Root>
      <NavigationHeader backTo={`/cards/${creditCardId}`} />
      <Title>{locales.title}</Title>
      <Subtitle>
        {shouldCopy ? locales.copySubtitle : locales.revealSubtitle}
      </Subtitle>

      {isLoading ? (
        <LoaderContainer>
          <SunshineLoader />
        </LoaderContainer>
      ) : (
        <PasscodeInput hidden onSubmit={onPasscodeSubmit} />
      )}
    </Root>
  );
};

export default CardDetailsPasscode;
